import React, { useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MetaData from "../meta-data";
import MainLayout from "../../components/layout/MainLayout";
import CampaignsDetails from "../../components/campaigns-details";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import useGetBasicCampaignsDetails from "../../api-manage/hooks/react-query/useGetBasicCampaignsDetails";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const router = useRouter();
  const id = router.query.id;
  const campaignsId = id?.split("-")[0];
  
  const { data, isLoading, isRefetching, refetch } = useGetBasicCampaignsDetails(campaignsId);
  
  useEffect(() => {
    if (campaignsId) {
      refetch();
    }
  }, [campaignsId, refetch]);

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `${data?.title || 'Campaign'}` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <CampaignsDetails
          campaignsDetails={data}
          configData={configData}
          isLoading={isLoading}
          isRefetching={isRefetching}
        />
      </MainLayout>
    </>
  );
};

export default Index;
